export default "__VITE_ASSET__f3f27652__"